import { concatQueryStrings, escape, formatTimestamp, predicate } from "views/logic/queries/QueryHelper";
export const formatQueryValue = (value, type) => (type == null ? void 0 : type.type) === "date" ? formatTimestamp(value) : escape(value);
export const orValuesClause = (values) => `(${concatQueryStrings(
  values.map(({ value, type }) => formatQueryValue(value, type)),
  { operator: "OR", withBrackets: false }
)})`;
export const fieldValueOrClause = (field, values) => `(${predicate(field, orValuesClause(values))})`;
